import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'Lucía M.',
  city: 'Rosario'
}, {
  name: 'Sofía R.',
  city: 'Córdoba Capital'
}, {
  name: 'Camila T.',
  city: 'Buenos Aires'
}, {
  name: 'Martina G.',
  city: 'Mendoza'
}, {
  name: 'Valentina L.',
  city: 'La Plata'
}, {
  name: 'Florencia P.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta S.',
  city: 'Tucumán'
}, {
  name: 'Agustina V.',
  city: 'Salta'
}, {
  name: 'Romina C.',
  city: 'San Juan'
}, {
  name: 'Daniela B.',
  city: 'Neuquén'
}];
export function RecentPurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNextPurchase();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPurchase = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    const randomMinutes = Math.floor(Math.random() * 15) + 1;
    setCurrentPurchase(randomPurchase);
    setMinutesAgo(randomMinutes);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup after 8-15 seconds
      const nextDelay = Math.floor(Math.random() * 7000) + 8000;
      setTimeout(showNextPurchase, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-188">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 flex max-w-[320px] items-center gap-3 rounded-xl bg-white p-3 shadow-xl border border-cream-200" data-id="element-189">
          <button onClick={() => setIsVisible(false)} className="absolute -right-2 -top-2 rounded-full bg-cream-200 p-1 text-brown-900 hover:bg-cream-300 transition-colors" data-id="element-190">
            <X className="h-3 w-3" data-id="element-191" />
          </button>

          <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md shadow-sm" data-id="element-192">
            <img src="https://cdn.magicpatterns.com/uploads/oq5ymwAaDAhMNDNwzMmZYu/Untitled_design-removebg-preview.png" alt="Del Horno a Tu Primer Ingreso" className="h-full w-full object-cover object-center" data-id="element-193" />
          </div>

          <div className="flex flex-col" data-id="element-194">
            <div className="flex items-center gap-1" data-id="element-195">
              <p className="text-sm font-semibold text-brown-900" data-id="element-196">
                {currentPurchase.name}
              </p>
              <CheckCircle2 className="h-3.5 w-3.5 text-green-500" data-id="element-197" />
            </div>
            <p className="text-xs text-brown-800/70" data-id="element-198">
              de {currentPurchase.city}
            </p>
            <p className="mt-0.5 text-xs font-medium text-burgundy-600" data-id="element-199">
              acaba de comprar este libro 🔥 hace {minutesAgo}{' '}
              {minutesAgo === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}